

































































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
import { RootStoreState } from '@/store';
import { State } from 'vuex-class';
import { FRIENDLY_NAME_NOT_REQUIRED_PRODUCTS } from './constants';
import { FriendlyNameNotRequiredProducts } from './types';

const regexValidChars = /^[a-z0-9-]+$/;
const regexStartsWithLetter = /^[a-z]/;
const regexLength = /^.{4,30}$/;

@Component({
  components:{
    ...UUIFComponent,
  },
})
export default class GetFriendlyName  extends SwExtendedVue {
  @Prop()
  values:any;
  @Watch('selectedDataCenterValue')
  private onValueChanges() {
    this.casdcarray.forEach((element:any) => {
      if (element.dataCenterName === this.selectedDataCenterValue) {
        this.selecteddc = element;
      }
    });
  }

  @Watch('selectedCasbApp')
  private onValuesChanges() {
    this.selectedCasbAppId = this.selectedCasbApp;
  }

  get options() {
    const arr :any[] = [];
    this.casdcarray.forEach((element:any) => {
      arr.push({
        id:element.dataCenterName,
        label:element.dataCenterDesc,
        value:element.dataCenterName,
      });
    });
    return arr;
  }

  get getcasbApps() {
    const arr:any[] = [];
    this.values.casbApps.forEach((element:any) => {
      arr.push({
        id:element.appValue,
        label:element.appName,
        value:element.appValue,
      });
    });
    return arr;
  }
  modalValues:any;
  cssPrefix = 'getfriendlyname';
  pageTitle:string = 'Provide Friendly Name';
  bisneeddc:boolean = false;
  friendlyName:string = '';
  modaltextfieldLabel:string = '';
  modalplaceholderLabel:string = '';
  serviceId:string = '';
  subDomain:string = '';
  bisvalid:boolean = true;
  bisimproper:boolean = false;
  selecteddc:any;
  casdcarray:any[] = [];
  selectedDataCenterValue:string = '';
  selectedCasbApp:string = '';
  selectedCasbAppId:string = '';
  isDomain:boolean = false;
  needcasbApps:boolean = false;
  domainName:string = '';
  subdomainAppName: string = '';
  showTermsandConditions: boolean = false;
  termsandConditionsLink: string = '';
  friendlyNameProducts: FriendlyNameNotRequiredProducts[] = [...FRIENDLY_NAME_NOT_REQUIRED_PRODUCTS];
  isCSEValid: boolean = true;
  isCESValid: boolean = true;
  sseSubdomainName: string = '';
  subdomainRegex = new RegExp('^[a-z][a-z0-9-]{3,62}$');
  sseDomainValidator: boolean = false;
  sseSubdomainError: string = '';
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedCustomer)
  selectedCustomer: string;

  mounted() {
    setTimeout(() => {
      const wrapper1 = document.getElementsByClassName('getfriendlyname__textfieldWrapper')[0] as HTMLElement;
      if (wrapper1) {
        wrapper1.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
      const wrapper2 = document.getElementsByClassName('getfriendlyname__subdomaintext')[0] as HTMLElement;
      if (wrapper2) {
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
        // tslint:disable-next-line:align
    }, 500);
    window.addEventListener('keypress', (event) => {
      if (event.keyCode === 13) {
        this.checkandgotoFreeTrial();
      }
    });
    this.bisneeddc = false;
    this.modaltextfieldLabel = 'FriendlyName';
    this.modalplaceholderLabel = 'Friendly Name';
    this.modalValues = this.values;
    // console.log(this.modalValues);
    // if ((this.modalValues.serviceId) &&
    //    (this.modalValues.serviceId === '6520' ||  this.modalValues.serviceId === '6560' ||
    //    this.modalValues.serviceId === '6732' || this.modalValues.serviceId === '6730' || this.modalValues.serviceId === '7115')) {
    //   this.serviceId = this.modalValues.serviceId;
    // }
    this.serviceId = this.modalValues.serviceId ? this.modalValues.serviceId : '';
    if (this.modalValues.productID === '402' || this.modalValues.productID === '410' || this.modalValues.productID === '403' || this.modalValues.productID === '401' || this.serviceId !== '') {
      this.pageTitle = 'Provide Capture API tenant details';
      if (this.modalValues.productID === '401') {
        this.pageTitle = 'Provide Capture Client details';
      }
      if (this.modalValues.productID === '402') {
        // this.showSubDomainMsg = true;
        this.pageTitle = 'Provide Cloud App Security tenant details';
        this.domainName = '.sonicwallcloudsec.com';
        this.subdomainAppName = 'SonicWall Cloud App Security';
      }
      if (this.modalValues.productID === '403') {
        // this.showSubDomainMsg = true;
        this.pageTitle = 'Provide Cloud Edge details';
        this.domainName = '.SonicWallEdge.com';
        this.subdomainAppName = 'Sonicwall Cloud Edge';
        this.showTermsandConditions = true;
        this.termsandConditionsLink = 'https://www.sonicwall.com/legal/sonicwall-cloud-edge-secure-access-agreement/';
      }
      if (this.modalValues.productID === '403') {
        this.isDomain = true;
        this.modaltextfieldLabel = 'Subdomain';
        this.modalplaceholderLabel = 'Subdomain';
      }
      if (this.modalValues.productID === '404') {
        this.pageTitle = 'Provide Cloud Email Security tenant details';
      }
      if (this.modalValues.productID === '412' && this.modalValues.needTsemdr === false) {
        this.pageTitle = 'Provide SonicWall Endpoint Security MDR friendly name';
      }
      if (this.modalValues.productID === '412' && this.modalValues.needTsemdr === true) {
        this.pageTitle = 'Provide SonicWall Endpoint Security MDR tenant details';
      }
      if (this.modalValues.productID === '402') {
        this.isDomain = true;
        this.modaltextfieldLabel = 'Subdomain';
        this.modalplaceholderLabel = 'Subdomain';
      }
      if (this.modalValues.productID === '409') {
        this.checkandgotoFreeTrial();
      }
      if (this.modalValues.productID === '410') {
        this.pageTitle = `${this.$t('freetrails.tscTitle').toString()}`;
      }
      if (this.modalValues.productID === '411') {
        this.pageTitle = `${this.values.widgetTitle.toString()}`;
      }
      if (this.modalValues.friendlyname && this.modalValues.friendlyname !== '' && this.modalValues.friendlyname !== 'undefined') {
        this.friendlyName = this.modalValues.friendlyname;
      }
      if (this.modalValues.subDomain && this.modalValues.subDomain !== ''  && this.modalValues.friendlyname !== 'undefined') {
        // this.isDomain = true;
        this.subDomain = this.modalValues.subDomain;
      }
      if (this.modalValues.needcasbdc && this.modalValues.needcasbdc === true) {
        // checking if the service is CASB. In this case, passing the serviceId as empty.
        if (this.serviceId === '6742'  || this.serviceId === '6837') {
          this.getCASDataCenters('', this.modalValues.productID);
        } else {
          this.getCASDataCenters(this.serviceId, this.modalValues.productID);
        }
      }
      if (this.modalValues.needCASBApp === true && this.modalValues.casbApps.length !== 0) {
        this.selectedCasbApp = this.values.casbApps[0].appValue;
      }
      if (this.modalValues.needCSE || this.modalValues.needCES) {
        this.pageTitle = this.modalValues.needCSE ? 'Provide Cloud Secure Edge tenant details' : 'Provide Cloud Email Security tenant details';
        this.bisneeddc = true;
        this.casdcarray = this.modalValues.datacenters;
        this.selecteddc = this.casdcarray[0];
        this.selectedDataCenterValue =  this.selecteddc.dataCenterName;
      }
      if (this.modalValues.needTSE) {
        this.pageTitle = `${this.$t('freetrails.tscTitle').toString()}`;
        this.bisneeddc = true;
        this.casdcarray = this.modalValues.datacenters;
        this.selecteddc = this.casdcarray[0];
        this.selectedDataCenterValue =  this.selecteddc.dataCenterName;
      }
      if (this.modalValues.needTsemdr) {
        this.bisneeddc = true;
        this.casdcarray = this.modalValues.datacenters;
        this.selecteddc = this.casdcarray[0];
        this.selectedDataCenterValue =  this.selecteddc.dataCenterName;
      }
    }
  }

  get showFriendlyName(): boolean {
    return this.values.productID !== this.getProductInfo('captureclient').productId &&
      this.values.productID !== this.getProductInfo('cloudsecureedge').productId;
  }

  get isCaptureClientFreetrials(): boolean {
    return this.values.productID === this.getProductInfo('captureclient').productId;
  }

  @Watch('sseSubdomainName')
  onSSESubdomainNameChange() {
    this.sseSubdomainError = '';

    if (!regexStartsWithLetter.test(this.sseSubdomainName)) {
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameStartsWith')}`;
    } else if (!regexValidChars.test(this.sseSubdomainName)) {
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameInvalid')}`;
    } else if (!regexLength.test(this.sseSubdomainName)) {
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameLengthError')}`;
    }
    this.sseDomainValidator = !!this.sseSubdomainError;
  }

  getProductInfo(product: string) {
    const selectedProduct = this.friendlyNameProducts.filter((ele: any) => { return   ele.value === product; })[0];
    return selectedProduct;
  }

  checkandgotoFreeTrial() {
    this.bisvalid = true;
    this.bisimproper = false;
    if (this.friendlyName === '' &&
      this.showFriendlyName &&
      this.modalValues.productID !== '411') {
      this.bisvalid = false;
      return;
    }
    if (this.sseSubdomainName === '' && this.values.needCSE) {
      this.isCSEValid = false;
      return;
    }
    if (this.sseSubdomainName === '' && this.values.needCES) {
      this.isCESValid = false;
      return;
    }
    if (this.modalValues.productID === '402' || this.modalValues.productID === '403') {
      if (!this.isValidCasbFriendlyName(this.friendlyName)) {
        this.bisimproper = true;
        // return;
      } else {
        if (this.friendlyName !== '' && this.values.needcasbdc === false && this.values.needCASBApp === false) {
          this.isDomain = false;
          this.$emit('gotoFreeTrial', { success:true, friendlyName: this.friendlyName, datacenter:this.selecteddc });
        } else if (this.friendlyName !== '' && this.values.needcasbdc === true && this.values.needCASBApp === false) {
          this.isDomain = false;
          this.bisneeddc = false;
          this.$emit('gotoFreeTrial', { success:true, friendlyName: this.friendlyName, datacenter:this.selecteddc });
        } else if (this.friendlyName !== '' && this.values.needcasbdc === false && this.values.needCASBApp === true) {
          this.isDomain = false;
          this.$emit('gotoFreeTrial', { success:true, friendlyName: this.friendlyName, casbapp:this.selectedCasbAppId });
        }
      }
    } else if (this.values.needCSE || this.values.needCES) {
      this.isDomain = false;
      this.bisneeddc = false;
      this.$emit('gotoFreeTrial', {
        success:true,
        friendlyName: this.friendlyName,
        datacenter:this.selecteddc,
        subDomain: this.sseSubdomainName,
      });
    } else if (this.friendlyName !== '' && this.values.needcasbdc === false) {
      this.isDomain = false;
      this.bisneeddc = false;
      this.$emit('gotoFreeTrial', { success:true, friendlyName: this.friendlyName, datacenter:this.selecteddc });
    } else if (this.friendlyName !== '' && this.values.needcasbdc === true) {
      this.isDomain = false;
      this.bisneeddc = false;
      this.$emit('gotoFreeTrial', { success:true, friendlyName: this.friendlyName, datacenter:this.selecteddc });
      // this.close();
    } else if (this.friendlyName === '' &&  this.values.productID === this.getProductInfo('captureclient').productId) {
      this.isDomain = false;
      this.bisneeddc = false;
      this.$emit('gotoFreeTrial', { success:true, friendlyName: this.friendlyName, datacenter:this.selecteddc });
    } else if (this.friendlyName === '' &&  this.values.productID === this.getProductInfo('cloudsecureedge').productId) {
      this.isDomain = false;
      this.bisneeddc = false;
      this.$emit('gotoFreeTrial', { success:true, friendlyName: `Cloud Secure Edge - ${this.selectedCustomer}`, datacenter:this.selecteddc });
    } else if (this.friendlyName === '' &&  this.modalValues.productID === '411') {
      this.isDomain = false;
      this.bisneeddc = false;
      this.$emit('gotoFreeTrial', { success:true, friendlyName: `${this.values.widgetTitle} - ${this.selectedCustomer}`, datacenter:this.selecteddc });
    }
  }
  close() {
    this.$emit('closeGetFriendlyname');
    this.showTermsandConditions = false;
    this.isDomain = false;
    this.bisneeddc = false;
  }
  getCASDataCenters(serviceId: any, productID: any) {
    const request = { serviceId, productID };
    this.$store.dispatch('MswProductsStoreModule/getCASDataCenter', request)
      .then((resp:any) => {
        if (resp.operationStatus === 'OK' && resp.msgCode ===  'MSWAPP:SUCCESS') {
          this.bisneeddc = true;
          this.casdcarray = resp.content.dataCenter;
          this.selecteddc = this.casdcarray[0];
          this.selectedDataCenterValue =  this.selecteddc.dataCenterName;
        }
        this.$store.commit('stopLoading');
      });
  }
  isValidCasbFriendlyName(friendlyName:string):boolean {
    const casbfriendlyNamePattern = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]$');
    if (casbfriendlyNamePattern.test(friendlyName)) {
      return true;
    }
    return false;
  }

}
